<template>
  <div class="pa-md-4">
    <v-tabs v-model="tabs" grow>
      <v-tab>
        <v-icon right>mdi-text</v-icon>
        افزدون محتوا
      </v-tab>
      <v-tab>
        <v-icon right>mdi-plus</v-icon>
        افزودن راهنمای کاربران
      </v-tab>
      <v-tab>
        <v-icon right>mdi-plus</v-icon>
        افزودن راهنمای کاربران
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <v-app>
          <v-container fluid>
            <v-card :loading="loading" elevation="2" outlined>
              <v-card-title>
                <!--v-if="$can('transaction_create')"-->
                <v-btn
                  v-status="'content_create'"
                  class="btn-add-with-text"
                  to="/content/create"
                >
                  <v-icon>mdi-plus</v-icon>
                  افزودن محتوا
                </v-btn>
                <!--          <v-spacer/>-->
                <!--          مدیریت محتوا-->
                <!--          <v-spacer/>-->
                <!--          <v-btn :loading="loading" @click="getData" class="btn-update">-->
                <!--            <v-icon>mdi-refresh</v-icon>-->
                <!--            به روزرسانی-->
                <!--          </v-btn>-->
              </v-card-title>
              <v-divider />
              <div class="row">
                <div class="col-md-12 p-5">
                  <data-table
                    :columns="columns"
                    :data="data"
                    :debounce-delay="5000"
                    :per-page="perPages"
                    :translate="translates"
                    orderDir="desc"
                    @on-table-props-changed="reloadTable"
                  />
                </div>
              </div>
            </v-card>
          </v-container>
        </v-app>
      </v-tab-item>
      <v-tab-item>
        <user-guide-store2 />
      </v-tab-item>
      <v-tab-item>
        <user-guide-store3 :id="$route.query.sid"></user-guide-store3>
        <!-- <list-help-infos></list-help-infos> -->
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Btn from "@/view/pages/content/contentBtnAction";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import userGuideStore from "../admin/userGuide/userGuideStore.vue";
import userGuideStore2 from "../admin/userGuide/userGuideStore2.vue";
import userGuideStore3 from "../admin/userGuide/userGuideStore3.vue";

//import list
export default {
  components: { userGuideStore, userGuideStore2, userGuideStore3 },
  data() {
    return {
      tabs: 0,
      url: "content",
      columns: [
        {
          label: "شناسه",
          name: "id",
          orderable: true,
          colStyle: "width: 100px;",
        },
        {
          label: "نام",
          name: "title",
          orderable: true,
          transform: (val) => {
            return val.data.title.length > 10
              ? val.data.title.substring(0, 10) + " ..."
              : val.data.title;
          },
        },
        {
          label: "نوع",
          name: "type",
          orderable: true,
        },
        {
          label: "لینک",
          name: "link",
          transform: (value, data) => {
            return value.data.link == null
              ? '<p class="text-danger">ندارد</p>'
              : value.data.link;
          },
          orderable: true,
        },
        {
          label: "نوع سرویس",
          name: "service",
          transform: (val) => {
            return this.$options.filters.serviceType(val.data.service.nameLand);
          },
        },
        {
          label: "تاریخ ویرایش",
          name: "updated_at",
          transform: (val) => {
            return this.$options.filters.longDate(val.data.updated_at);
          },
        },
        {
          label: "عملیات",
          name: "actions",
          type: "html",
          component: Btn,
          handler: this.action,
          event: "action",
          meta: {
            permission_prefix: "content_",
          },
        },
      ],
      data: {},
      // loading: false,
      intro: "0",
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
      },
      query: { sort: "id", order: "desc", limit: 25, s: "" },
      xprops: {
        module: "ContentIndex",
        route: "content",
        content_prefix: "content_",
        fetchIndexData: "fetchIndexData",
      },
    };
  },
  mounted() {
    this.tabs = parseInt(this.$route.query.tabs || 0);
  },
  created() {
    this.getData(this.url);
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t(this.$route.meta.title) },
    ]);
  },

  beforeDestroy() {
    this.resetState();
  },

  computed: {
    ...mapGetters(["layoutConfig"]),
    ...mapGetters("ContentIndex", ["contents", "total", "loading"]),

    config() {
      return this.layoutConfig();
    },
  },

  methods: {
    getData(url = this.url, options = this.tableProps) {
      this.loading = true;
      this.requestApiGet(this.url, options).then((response) => {
        this.data = response.data;
        this.loading = false;
      });
    },

    reloadTable(tableProps) {
      this.getData(this.url, tableProps);
    },

    action(data, type) {
      this[type](data);
    },
    delete(data) {
      this.$swal({
        text: "آیا از حذف این  محتوا اطمینان دارید؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "بله",
        cancelButtonText: "خیر",
        reverseButtons: true,
        confirmButtonClass: "btn btn-danger",
        cancelButtonClass: "btn btn-secondary",
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.requestApiDelete(`content/${data.id}`).then((response) => {
            this.reloadTable(this.tableProps);
            this.$toast.success("دسته بندی با موفقیت حذف شد");
          });
        }
      });
    },

    edit(data) {
      this.$router.push({ name: "content.edit", params: { id: data.id } });
    },
    ...mapActions("ContentIndex", ["fetchIndexData", "setQuery", "resetState"]),
  },
};
</script>
